import React from "react";

const NewsletterForm = ({subscriptionList}) => {
  return <>
    <form className="relative" action="https://mail.cromattica.com/subscribe" method="POST" acceptCharset="utf-8">
      <input
        id="email"
        type="email"
        name="email"
        placeholder="Email address"
        className="dark:bg-jacarta-700 dark:border-jacarta-600 focus:ring-accent border-jacarta-50 w-full rounded-full border py-3 px-4 dark:text-white dark:placeholder-white"
      />
      <div className='hidden'>
        <label htmlFor="hp">HP</label><br/>
        <input type="text" name="hp" id="hp"/>
      </div>
      <input type="hidden" name="list" value={subscriptionList}/>
      <input type="hidden" name="subform" value="yes"/>
      <input className="hover:bg-accent-dark font-display bg-accent absolute top-2 right-2 rounded-full px-6 py-2 text-sm text-white" type="submit" name="submit" id="submit"/>
    </form>
  </>
};

export default NewsletterForm;
